import React from 'react'
import './Banner.scss'
import logo from '../../assets/logo.png'
import Button from '../../components/Button/Button'

import banner_pc from '../../assets/bg.jpg'
import banner_mobile from '../../assets/banner_mobile.jpg'
import QRCode from '../../assets/QRCode.png'

function Banner() {

  return <div className="banner_background">
    <img className=" banner_content_background_pc" src={banner_pc}></img>
    <img className=" banner_content_background_mobile" src={banner_mobile}></img>
    <div className="banner_content_container">
      <img alt="logo" className="banner_logo" src={logo}></img>
      <h1 className="banner_title">一站式3D展销升级云服务</h1>
      <Button className="banner_button"><a href="#form" className="button_link">立即申请体验</a></Button>
      <div className="banner_QRcode_container">
      <img src={QRCode} className="banner_QRCode"/>
      <p>扫一扫 添加业务咨询微信<br/>1对1专属免费咨询服务</p>
      </div>
    </div>
  </div>
}

export default Banner